// src/pages/materials/catalog/materialsCatalog.ua.js
/** value — внутрішній ключ; label — українська назва (з EN у дужках);
 *  category: 'plant' | 'animal' | 'premium' | 'manmade'
 *  premium: true для елітних волокон
 */
export const MATERIALS_UA = [
  // Рослинні
  { value: 'cotton',      label: 'Бавовна (Cotton)',                 category: 'plant' },


  { value: 'linen',       label: 'Льон (Linen)',                     category: 'plant' },
  { value: 'hemp',        label: 'Коноплі (Hemp)',                   category: 'plant' },
  { value: 'ramie',       label: 'Рамі (Ramie)',                     category: 'plant' },
  { value: 'jute',        label: 'Джут (Jute)',                      category: 'plant' },
  { value: 'bamboo-vis',  label: 'Бамбукове волокно (Bamboo Viscose)', category: 'plant' },
  { value: 'kapok',       label: 'Капок (Kapok)',                    category: 'plant' },
  // Тваринні (звичайні)


        // Шкіра та хутро
{ value: 'leather',      label: 'Шкіра (Leather)',                    category: 'animal' },
{ value: 'suede',        label: 'Замша (Suede)',                      category: 'animal' },
{ value: 'nubuck',       label: 'Нубук (Nubuck)',                     category: 'animal' },
{ value: 'shearling',    label: 'Овчина з хутром (Shearling)',        category: 'animal' },
{ value: 'fur',          label: 'Хутро (Fur)',                        category: 'animal' },



  { value: 'wool',        label: 'Вовна (Wool)',                     category: 'animal' },
  { value: 'merino',      label: 'Мерінос (Merino Wool)',            category: 'animal' },
  { value: 'alpaca',      label: 'Альпака (Alpaca)',                 category: 'animal' },
  { value: 'mohair',      label: 'Мохер (Mohair)',                   category: 'animal' },
  { value: 'angora',      label: 'Ангорa (Angora)',                  category: 'animal' },
  { value: 'camel',       label: 'Верблюжа шерсть (Camel Hair)',     category: 'animal' },
  { value: 'yak',         label: 'Як (Yak Wool)',                    category: 'animal' },
  { value: 'cashgora',    label: 'Кашгора (Cashgora)',               category: 'animal' },
  { value: 'silk',        label: 'Шовк (Silk)',                      category: 'animal' },
  { value: 'tussah',      label: 'Тусса (Tussah Silk)',              category: 'animal' },
  // Преміум / рідкісні тваринні
  { value: 'cashmere',    label: 'Кашемір (Cashmere)',               category: 'premium', premium: true },
  { value: 'vicuna',      label: 'Вікуня (Vicuña)',                  category: 'premium', premium: true },
  { value: 'guanaco',     label: 'Гуанако (Guanaco)',                category: 'premium', premium: true },
  { value: 'qiviut',      label: 'Ківіут / мускус-окс (Qiviut)',     category: 'premium', premium: true },
  { value: 'shahtoosh',   label: 'Шахтуш (Shahtoosh)*',              category: 'premium', premium: true },
  // *історично-делікатний/заборонений у торгівлі — додано як довідковий тег, не для закупівлі

  // Штучні/хімічні (віскозні та ін.)
  { value: 'viscose',     label: 'Віскоза (Viscose)',                category: 'manmade' },
  { value: 'modal',       label: 'Модал (Modal)',                    category: 'manmade' },
  { value: 'cupro',       label: 'Купра (Cupro)',                    category: 'manmade' },
  { value: 'lyocell',     label: 'Ліоцел / Тенсель (Lyocell/Tencel)', category: 'manmade' },
  { value: 'acetate',     label: 'Ацетат (Acetate)',                 category: 'manmade' },
  // Синтетичні
  { value: 'polyester',   label: 'Поліестер (Polyester)',            category: 'manmade' },
  { value: 'nylon',       label: 'Нейлон / Поліамід (Nylon/PA)',     category: 'manmade' },
  { value: 'elastane',    label: 'Еластан / Спандекс (Elastane)',    category: 'manmade' },
  { value: 'acrylic',     label: 'Акрил (Acrylic)',                  category: 'manmade' },
  { value: 'polypropylene',label:'Поліпропілен (PP)',                category: 'manmade' },
  { value: 'pvс',         label: 'ПВХ-ниті (PVC)',                   category: 'manmade' },
    { value: 'eco-leather',  label: 'Екошкіра / штучна шкіра (Eco Leather / PU)', category: 'manmade' },
{ value: 'vegan-leather',label: 'Веган-шкіра (Vegan Leather / Plant-based)', category: 'manmade' },

  // Додаткові (для повноти у fashion/tech):
  { value: 'linen-hemp',  label: 'Лляно-конопляне волокно (Linen/Hemp)', category: 'plant' },
  { value: 'silk-cotton', label: 'Шовк-бавовна (Silk/Cotton)',       category: 'premium', premium: true },
  { value: 'wool-silk',   label: 'Вовна-шовк (Wool/Silk)',           category: 'premium', premium: true },
  { value: 'muga',        label: 'Муга (Muga Silk)',                 category: 'premium', premium: true },
  { value: 'eri',         label: 'Ері (Eri Silk)',                    category: 'premium', premium: true },
];
